/* istanbul ignore next */
(function (angular) {
        'use strict';
        angular.module('bm.practice.billing', [
                'billing.templates',
                'trta.practice.billing.BillingSelectionAndReviewPageController',
                'trta.practice.billing.WipListDirectiveController',
                'trta.practice.billing.WipListPage',
                'trta.practice.billing.WipListProvider',
                'trta.practice.billing.wipList',

                'trta.practice.billing.ReviewInvoicesDirectiveController',
                'trta.practice.billing.ReviewInvoicesPage',
                'trta.practice.billing.reviewInvoicesList',

                'trta.practice.billing.CreateStatementsPage',

                'trta.practice.billing.trtaPracticeBillingInvoiceDetails',
                'trta.practice.billing.disableBasedOnFormAndControlGroup',
                'trta.practice.billing.DetailBillingProvider',
                'trta.practice.billing.DetailBillingDirectiveController',

                'trta.practice.billing.DetailBillingQuickBillDirectiveController',

                'trta.practice.billing.trtaPracticeMultiClientDetailBillingDirective',
                'trta.practice.billing.MultiClientDetailBillingPage',
                'trta.practice.billing.MultiClientDetailBillingDirectiveController',

                'trta.practice.billing.DetailBillingSession',
                'bm.practice.billing.component.BillingComponentDirective',

                'bm.practice.billing.fixedfee',
                'bm.practice.billing.latefee',
                'bm.practice.billing.FormatTemplatesPageController',
                'bm.practice.billing.sendModal'
        ]);
} (window.angular));
